import { isScoreRangeValid } from 'shared-utils';
import { Table } from 'flowbite-react';
import { PositionSkill } from '../job/postionDrawer/PositionDrawer';

interface Props {
	positionSkills: PositionSkill[];
	onlyDesktop: boolean;
}

const SkillComparisonTable = ({ positionSkills, onlyDesktop }: Props) => {
	return (
		<div className={`mt-4 flex flex-col gap-2 ${onlyDesktop ? 'sm:hidden' : 'md:hidden overflow-scroll'} `}>
			<Table className="overflow-hidden rounded-[4px]">
				<Table.Head>
					<Table.HeadCell className="border border-solid text-[#1F3343] bg-[#FAFAFC] dark:border-[#111E2C] dark:border-b-[#1f2a37] dark:bg-[#111E2C] dark:text-[#E5FFFF]">
						Skill
					</Table.HeadCell>

					<Table.HeadCell className="border border-solid text-[#1F3343] bg-[#FAFAFC] dark:border-[#111E2C] dark:border-b-[#1f2a37] dark:bg-[#111E2C] dark:text-[#E5FFFF]">
						Your Score
					</Table.HeadCell>

					<Table.HeadCell className="border border-solid text-[#1F3343] bg-[#FAFAFC] dark:border-[#111E2C] dark:border-b-[#1f2a37] dark:bg-[#111E2C] dark:text-[#E5FFFF]">
						Required Score
					</Table.HeadCell>
				</Table.Head>
				<Table.Body>
					{positionSkills?.map(ps => {
						return (
							<Table.Row className="border-y dark:border-[#1f2a37]" key={ps.id}>
								<Table.Cell className="dark:bg-[#18222D] bg-[#FAFAFC] text-[#1F3343] dark:text-white">
									{ps.name}
								</Table.Cell>

								<Table.Cell className="dark:bg-[#18222D] bg-[#FAFAFC] text-[#1F3343] dark:text-white">
									{Math.round(ps.rating) !== -1 ? `${isScoreRangeValid(Math.round(ps.rating))}` : 'NA'}
								</Table.Cell>

								<Table.Cell className="dark:bg-[#18222D] bg-[#FAFAFC] text-[#1F3343] dark:text-white">
									{Math.round(ps.threshold)}
								</Table.Cell>
							</Table.Row>
						);
					})}
				</Table.Body>
			</Table>
		</div>
	);
};

export default SkillComparisonTable;
